import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaInstagram, FaFacebook, FaWhatsapp } from 'react-icons/fa';
import ContactInfoCard from '../ContactInfoCard/ContactInfoCard';
import ContactSocialCard from '../ContactInfoCard/ContactSocialCard';
import ContactLocationCard from '../ContactInfoCard/ContactLocationCard';
import '../../styles/routes/contactPage.css';

const ContactPage = () => {


    // Separado em 3 seções: Contato, Onde nos encontrar e Redes Sociais
    // Pagina de contato acrescente icone e o telefone / dado de contatos
    const contactInfo = [
        { icon: <FaPhone className='contactIcon' />, text: "Matriz: 0800 009 4444" },
        { icon: <FaPhone className='contactIcon' />, text: "Tel.: (49) 3644-4444" },
        { icon: <FaPhone className='contactIcon' />, text: "Filial SAS (46) 3563-3000" },
        { icon: <FaEnvelope className='contactIcon' />, text: "nettri@nettri.com.br" }
    ];

    const contactLocations = [
        { icon: <FaMapMarkerAlt className='contactIcon' />, text: "Barracão - PR", url: "https://maps.app.goo.gl/eyCdHf8S2hC7mTYY8" },
        { icon: <FaMapMarkerAlt className='contactIcon' />, text: "Santo Antônio do Sudoeste - PR", url: "https://maps.app.goo.gl/n4MUuHvALHeMpRJL8" },
        { icon: <FaMapMarkerAlt className='contactIcon' />, text: "Bom Jesus do Sul - PR", url: "https://maps.app.goo.gl/Z2cJghsVV9EXs3kU8" },
        /*
        {icon={<FaMapMarkerAlt className='contactIcon' />} text="Dionísio Cerqueira - SC" },
        {icon={<FaMapMarkerAlt className='contactIcon' />} text="Flor da Serra do Sul - PR" },
        {icon={<FaMapMarkerAlt className='contactIcon' />} text="Pranchita - PR"},

        */
    ];

    const socialMedia = [
        { icon: <FaInstagram className='contactIcon' />, text: "Instagram", socialType: "instagram", url: "https://www.instagram.com/nettri.oficial?igsh=dnAzcXYxeXNna29v" },
        { icon: <FaFacebook className='contactIcon' />, text: "Facebook", socialType: "facebook", url: "https://www.facebook.com/nettri.oficial?mibextid=ZbWKwL" },
        { icon: <FaWhatsapp className='contactIcon' />, text: "Whatsapp", socialType: "whatsapp", url: "https://api.whatsapp.com/send?phone=554936444444&text=Olá.%20Gostaria%20de%20saber%20mais." }
    ];

    return (
        <div className='sectionContact'>
            <h1>Entre em Contato</h1>

            <div className='contactDetails'>
                {contactInfo.map((contact, index) => (
                    <ContactInfoCard key={index} icon={contact.icon} text={contact.text} />
                ))}
            </div>

            <h2>Onde nos encontrar</h2>
            <div className='contactDetails'>
                {contactLocations.map((location, index) => (
                    <ContactLocationCard key={index} icon={location.icon} text={location.text} url={location.url} />
                ))}
            </div>

            <h2>Redes Sociais</h2>
            <div className='contactDetails'>
                {socialMedia.map((social, index) => (
                    <ContactSocialCard key={index} icon={social.icon} text={social.text} socialType={social.socialType} url={social.url} />
                ))}
            </div>
        </div>
    );
}

export default ContactPage;